import type { SiteComprehensiveStatusApiResponse } from '@/types/site';
import { XHRAuthorizedClient } from '../client';
import { ENDPOINTS } from '../endpoints';

export const fetchSiteComprehensiveStatus = async (siteId: string) => {
  const response =
    await XHRAuthorizedClient.get<SiteComprehensiveStatusApiResponse>(
      ENDPOINTS.dashboard.comprehensiveStatus(siteId)
    );

  return response.data.data;
};
